const LOCAL_API_HOSTS = new Set(['localhost', '127.0.0.1', '::1']);
const BOTSPOT_FRONTEND_HOSTS = new Set(['botspot.trade', 'www.botspot.trade', 'dev.botspot.trade']);
const DEV_API_URL = 'https://api.dev.botspot.trade';
const PRODUCTION_API_URL = 'https://api.botspot.trade';

export const isLocalApiUrl = (value) => {
  if (!value) return false;
  try {
    const parsed = new URL(value);
    return LOCAL_API_HOSTS.has(parsed.hostname);
  } catch {
    return false;
  }
};

export const isHostedHostname = (hostname) => Boolean(hostname && !LOCAL_API_HOSTS.has(hostname));

export const isHostedFrontendUrl = (value) => {
  if (!value) return false;
  try {
    const parsed = new URL(value);
    return BOTSPOT_FRONTEND_HOSTS.has(parsed.hostname);
  } catch {
    return false;
  }
};

export const getApiBaseUrl = ({
  configured = process.env.REACT_APP_API_URL,
  hostname = typeof window !== 'undefined' ? window.location?.hostname : undefined
} = {}) => {
  const configuredLooksWrongForHostedSite =
    isHostedHostname(hostname) &&
    (isLocalApiUrl(configured) || isHostedFrontendUrl(configured));

  if (configured && !configuredLooksWrongForHostedSite) {
    return configured.replace(/\/$/, '');
  }

  if (isHostedHostname(hostname)) {
    if (hostname === 'dev.botspot.trade') {
      return DEV_API_URL;
    }
    return PRODUCTION_API_URL;
  }

  return (configured || '').replace(/\/$/, '');
};

export default getApiBaseUrl;
